import { Open_Sans } from 'next/font/google'

const OpenSansFont = Open_Sans({
	variable: '--font-open-sans',
	weight: ['300', '400', '500', '700'],
	subsets: ['latin'],
	display: 'swap'
})

export default OpenSansFont
